import { Tooltip } from "antd";
import styles from "../statistics.module.css";

export function AssetsScoreDistribution({ assetsScoreDistribution }) {
  const percentages = [
    {
      label: ">40",
      value: assetsScoreDistribution?.percentages?.low.percent,
      tooltip: assetsScoreDistribution?.percentages?.low.count,
      width: 340,
      color: "#F27281",
    },
    {
      label: ">60",
      value: assetsScoreDistribution?.percentages?.mid.percent,
      tooltip: assetsScoreDistribution?.percentages?.mid.count,
      width: 310,
      color: "#F5B452",
    },
    {
      label: ">80",
      value: assetsScoreDistribution?.percentages?.high.percent,
      tooltip: assetsScoreDistribution?.percentages?.high.count,
      width: 210,
      color: "#4DC7B5",
    },
  ];
  return (
    <div className={styles.statisticsContent}>
      <h2 className={styles.statisticsTitle}> Assets Score Distribution</h2>
      <div className={styles.statisticsColoredBar}>
        {" "}
        <div className={styles.statisticContent}>
          {percentages?.map((item, index) => (
            <div
              key={index}
              className={`custom-tooltip ${styles.statisticItem}`}
              style={{ width: `${item.width}px` }}
            >
              <p>{item.label}</p>
              <Tooltip
                placement="top"
                align={{ offset: [80, -10] }}
                title={
                  <div className={styles.myTooltipBox}>
                    <div className={styles.myTooltipValue}>
                      Assets: {Math.round(item.tooltip)}
                    </div>
                    <div className={styles.myTooltipArrow}></div>
                  </div>
                }
                color="transparent"
                overlayInnerStyle={{
                  background: "transparent",
                  padding: 0,
                  boxShadow: "none",
                  width: 100,
                }}
              >
                <div
                  className={`${styles.bar} ${index === percentages?.length - 1 ? styles.noAfter : ""
                    }`}
                  style={{
                    width: `100%`,
                    backgroundColor: item.color || "#ccc",
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                  }}
                >
                  {item.value && <span>{Math.round(item.value)}%</span>}
                </div>
              </Tooltip>
            </div>
          ))}
        </div>{" "}
        <div className={styles.divider}></div>
        <div className={styles.statisticTableWrapper}>
          <div className={styles.statisticTableColumn}>
            <h3 className={styles.statisticTableTitle}> Best Assets</h3>
            <div className={styles.statisticTableContent}>
              <div>Asset</div>
              <div>Score</div>
            </div>
            {assetsScoreDistribution?.bests?.map((item, index) => (
              <div key={index} className={styles.statisticTableContent}>
                <div>{item.asset_name}</div>
                <div className={styles.score}>
                  {Math.round(item.new_assets_total_score)}
                </div>
              </div>
            ))}
          </div>
          <div className={styles.statisticTableColumn}>
            <h3 className={styles.statisticTableTitle}> Worst Assets</h3>
            <div className={styles.statisticTableContent}>
              <div>Asset</div>
              <div>Score</div>
            </div>
            {assetsScoreDistribution?.worsts?.map((item, index) => (
              <div key={index} className={styles.statisticTableContent}>
                <div>{item.asset_name}</div>
                <div className={styles.score}>
                  {Math.round(item.new_assets_total_score)}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
